import SimpleSelector from "~/components/product/VariantSelector/SimpleSelector"
import { useVariantPossibilities } from "@decocms/apps-commerce/sdk/useVariantPossibilities"
import { Product } from "@decocms/apps-commerce/types"

import MultiSelector from "./MultiSelector"
import { useOffer } from "~/sdk/useOffer"

interface Props {
    isMobile?: boolean
    product: Product
}

const REVERSE = ['estampa', 'cor']

export default function VariantSelector({ product }: Props) {
    const hasVariant = product.isVariantOf?.hasVariant ?? []
    const possibilities = useVariantPossibilities(hasVariant, product)
    const possibilitiesKeys = Object.keys(possibilities)
    const isCurrentProductAvailable =
        useOffer(product.offers).availability === 'https://schema.org/InStock'

    // Remount the selector when the product changes: SPA navigation between two
    // PDPs reuses this component instance, so any mount-only state (the
    // selectedProducts reset) would never re-run and the previous product's
    // selection would leak into the new grid.
    const productKey = product.isVariantOf?.productGroupID ?? product.productID

    if (possibilitiesKeys.length > 1) {
        const reversed = possibilitiesKeys.some((x) => REVERSE.includes(x.toLowerCase()))

        return (
            <MultiSelector
                key={productKey}
                hasVariant={hasVariant}
                selector={possibilitiesKeys[0]}
                isCurrentProductAvailable={isCurrentProductAvailable}
                reverse={reversed}
            />
        )
    }

    return (
        <SimpleSelector
            key={productKey}
            hasVariant={hasVariant}
            isCurrentProductAvailable={isCurrentProductAvailable}
        />
    )
}
